import { useRef, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { Chip, TextField } from "@mui/material";

export default function PillsAutocomplete({
  value = [],
  setValue,
  options = [],
  getOptionId = (option) => option?.id ?? option,
  getOptionLabel = (option) => option?.label ?? option?.name ?? String(option),
  label,
  placeholder = "Type, ↑/↓, Enter or Tab"
}) {
  const [inputValue, setInputValue] = useState("");
  const highlightedRef = useRef(null);

  const isSelected = (option) =>
    value.some((selected) => getOptionId(selected) === getOptionId(option));

  return (
    <Autocomplete
      multiple
      size="small"
      options={options}
      filterSelectedOptions
      openOnFocus={false}
      autoHighlight
      value={value}
      inputValue={inputValue}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, selected) =>
        getOptionId(option) === getOptionId(selected)
      }
      onChange={(event, newValue) => {
        setValue(newValue);
        setInputValue("");
        highlightedRef.current = null;
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onHighlightChange={(event, option) => {
        highlightedRef.current = option;
      }}
      renderTags={(selectedValue, getTagProps) =>
        selectedValue.map((option, idx) => {
          const { key, ...tagProps } = getTagProps({ index: idx });

          return (
            <Chip
              key={key ?? getOptionId(option)}
              label={getOptionLabel(option)}
              {...tagProps}
              size="small"
            />
          );
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={(value ?? []).length === 0 ? placeholder : undefined}
          onKeyDown={(event) => {
            if (event.key === "Tab" && inputValue) {
              event.preventDefault();

              let toSelect = highlightedRef.current;

              if (!toSelect || isSelected(toSelect)) {
                toSelect = options.find(
                  (option) =>
                    !isSelected(option) &&
                    getOptionLabel(option)
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                );
              }

              if (toSelect) {
                const newValue = [...value, toSelect];
                setValue(newValue);
                setInputValue("");
                highlightedRef.current = null;
              }
            }
          }}
        />
      )}
    />
  );
}
